<div class="container-fluid">
    <div class="row">
        <div class="modal-body" id="request_success_msg">
            <div class="row" id="success_style">
                <div class="col-12 p-3 zsd-cust-common-pageheading-font">{{ 'ReportIncident.confirmation' | translate }}
                    <span><em class="fas fa-times float-right" style="cursor: pointer;" (click)="cancelRequest()" data-dismiss="modal"></em></span>
                </div>
                <div class="col-12 pt-0 pl-3 pr-3 pb-4">{{ createdRequestResponse.requestId }}
                        {{ 'ReportIncident.requestcreatedsuccessfully' | translate }}
                </div>
            </div>

            <div *ngIf="createdRequestResponse.hasProposedSolution" class="row">
                <div class="col-12 p-3 zsd-cust-common-pageheading-font">
                    {{ 'ReportIncident.proposedsolutionfound' | translate }}</div>
                <div class="col-12 pt-0 pl-3 pr-3 pb-4">{{ 'ReportIncident.viewproposedsolutionmessage' | translate }}
                </div>
            </div>

            <div class="text-center" id="redirectbutton">
                <button type="button" *ngIf="createdRequestResponse.hasProposedSolution"
                    class="btn zsd-cust-filter-button mt-2" id="zsd_cust_button_create" data-dismiss="modal"
                    [routerLink]="[showProposedSolutionPage(createdRequestResponse.requestId)]">
                    {{ 'ReportIncident.viewproposedsolution' | translate }}</button>

                <button type="button" class="btn zsd-cust-filter-button mt-2" id="zsd_cust_button_cancel"
                    data-dismiss="modal" [routerLink]="['/requests']">
                    {{ 'ReportIncident.redirecttorequestpage' | translate }} </button>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="report_incident_row">
            <form (ngSubmit)="createRequest()" [formGroup]="reportIncidentForm">

                 <div *ngIf="serverError!=null" class="alert alert-danger mt-3" [innerHTML]="serverError">
                </div>
    
                <!--Incident subject-->

                <!-- Item Selection --> <!--[fromNewRequestPage]=fromNewRequestPage-->
                <div  *ngIf="itemId; else elseBlock" class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <zsd-itemselection [processIndex]=processIndexString  [itemId]=itemId  (isformValid)="isItemSelectionformvalid($event)"
                        [parentForm]="reportIncidentForm"></zsd-itemselection>
                </div>
                <ng-template #elseBlock > <!-- [fromNewRequestPage]=fromNewRequestPage-->
                <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                        <zsd-itemselection [processIndex]=processIndexString (isformValid)="isItemSelectionformvalid($event)"
                        [parentForm]="reportIncidentForm"></zsd-itemselection>
                </div>                
                </ng-template>

                <!-- Custom Fields Component -->
                <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <zsd-customfields [parentForm]="reportIncidentForm" [customFields]="customFields" [fromQuickCall]=false [id]="null">
                    </zsd-customfields>
                </div>

                <!-- Additional Information -->
                <div *ngIf=showAdditionalInfo class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <zsd-additionalinfo [showLineManager]=false [parentForm]="reportIncidentForm"></zsd-additionalinfo>
                </div>

                <!-- Contact Information-->
                <div *ngIf=showAdditionalInfo class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <zsd-contactinfo [parentForm]="reportIncidentForm"></zsd-contactinfo>
                </div>

                <!-- Request CC Field -->
                <div *ngIf=showNotifyField class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <div class="row mt-3">
                    <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12 pl-0">  
                        <label for="requestCC" id="sd_request_cc">{{'ReportIncident.CCField' | translate}}
                        </label>
                    </div>    
                    <div class="cc_input_field col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                            <div class="cc-area">
                              <div class="cc-details" (click)="setFocusToCCField();">
                                <div class="selected-user" *ngFor="let user of ccList;let i=index">
                                  <span>{{getUserDisplayString(user)}}<span id="remove_icon" class="icon-cancel-circle"
                                      (click)="removeFromCCList(i)"><em class="fas fa-times-circle"></em></span></span>
                                  <!-- <button class="btn btn-info btn-sm remove-user-btn" type="submit" (click)="removeFromCCList(i)">&times;</button> -->
                                </div>
                                <div>
                                  <input [attr.id]="'input-user' + index" type="text" class="form-control input-user"
                                    aria-describedby="ccField" [formControl]="ccField" (keydown)="ccListKeyPressAction($event)"
                                    autocomplete="off">
                                  <div *ngIf="ccField?.value?.length > 1" class="searchList" id="reportincident-search-list" (scroll)="scrollEndForCustomerSearch()">
                                    <span *ngIf="usersLoading">{{'RequestDetail.loading' | translate}}</span>
                                    <a [attr.id]="'user' + i" class="dropdown-item" [ngClass]="{'active-element-in-list': i === currentCcUserIndex}" (click)="addToCCList(user);"
                                      *ngFor="let user of userSearchInfo.results; let i = index">{{getUserDisplayString(user)}}</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>  
                        </div>
                </div>
                <!-- Request CC Field End-->

                <div *ngIf="showSubject" class="row mt-3" id="sd_incident_subject_field">
                    <div class="col-md-2 col-lg-2 col-xl-2">
                        <label for="incidentSubject" id="sd_incident_subject_label">
                            {{ 'ReportIncident.requestSubject' | translate }}
                            <span *ngIf="subjectRequired" id="mandatory_field">&#42;</span>
                        </label>
                        <br />
                    </div>
                    <div class="col-md-10 col-lg-10 col-xl-10">
                        <div>
                            <input class="form-control" id="sd_incident_subject" type="text" name="incidentSubject"
                                [(ngModel)]="incidentSubject" formControlName="incidentSubject"
                                (focus)="subjectFieldFocus = true" (blur)="subjectFieldFocus = false" [ngClass]="{'error-class':subjectRequired && reportIncidentForm.controls['incidentSubject'].touched
                                            && !subjectFieldFocus && subjectEmpty()}" maxlength="255">
                        </div>
                        <div *ngIf="subjectRequired && reportIncidentForm.controls['incidentSubject'].touched 
                                        && !subjectFieldFocus && subjectEmpty()"
                            class="validation-error-inline text-danger">
                            {{ 'ReportIncident.subjectValueRequiredError' | translate }}
                        </div>
                    </div>
                </div>

                <!--Ticket Description-->
                <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-3">
                    <div class="row">
                        <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                            <label for="ticketDescription"
                                id="sd_ticket_desc">{{ 'ReportIncident.ticketDescription' | translate }}
                                <span id="mandatory_field">&#42;</span>
                            </label>
                        </div>

                        <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                            <zsd-tinymce [parentForm]="reportIncidentForm" [required]=true
                                [requiredError]="'ReportIncident.descriptionRequired' | translate"></zsd-tinymce>
                        </div>
                    </div>
                </div>


                <!-- File Upload Component -->
                <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-3">
                    <div class="row">
                        <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                            <label for="attachment">{{ 'ReportIncident.attachment' | translate }}
                            </label>
                        </div>
                        <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12" id="attachment_upload">
                            <zsd-fileupload (isformValid)="isfileuploadformvalid($event)"
                                (filesSelected)="selectedFilesList($event)"></zsd-fileupload>
                        </div>
                    </div>
                </div>

                <div id="zsd_button_separation_line">
                </div>

                <!--Create & Cancel Button-->
                <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                    <div class="row">
                        <div class="col-lg-5 col-md-5 col-xl-5">&nbsp;</div>
                        <div class="col-lg-2 col-md-1 col-xl-2 col-sm-12 col-12" id="sd_reportincident_spinner">
                            <div *ngIf="loading" id="spinner" role="progressbar">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-6 col-xl-5 col-sm-12 col-12">
                            <div class="form-group float-right">
                                <button type="submit" class="btn zsd_button"
                                    id="zsd_cust_button_create">{{ 'ReportIncident.createButton' | translate }}</button>
                                <button type="button" class="btn zsd_button" id="zsd_cust_button_cancel"
                                    data-dismiss="modal"
                                    (click)="cancelRequest()">{{ 'ReportIncident.cancelButton' | translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>